module.exports = __webpack_public_path__ + "static/media/FPLEVolutionLogo_Horizontal_LeftJustified_2925.cd41307c.png";